import { TKeys } from './types'

export const fr_fr: Record<TKeys, string> = {
    // SCREENS
    // General
    loading: 'Chargement...',
    // SignIn
    signin_title: 'Connexion',
    signin_redirect_title: 'Vérifiez vos identifiant et mot de passe',
    psw_placeholder_redirect: 'Confirmer le mot de passe',
    psw_placeholder: 'Mot de passe',
    email_placeholder: 'Adresse e-mail',
    language: 'Langue',
    forgot_password: 'Mot de passe oublié ?',
    signup_hint: 'Pas de compte ? Inscrivez-vous',
    btn_signin: 'Se connecter',
    // Intro
    // N-Ary sort
    my_profile: 'Mon profil',
    btn_submit: 'Confirmer',
    btn_finish: 'Terminer',
    hint_undo: 'Êtes-vous sûr de vouloir annuler votre dernière action ?',
    // Global screen
    tip_quit: 'Êtes-vous sûr de vouloir quitter ?',
    // State screen
    intro_title: 'Le bonheur est la clé du succès',
    intro_body: `Si vous aimez ce que vous faites et l'équipe avec laquelle vous travaillez, vous réussirez dans votre vie professionnelle.`,
    howto1_title: `Vous allez voir 2 déclarations
    
    Cliquez sur celle que vous préférez

    Cela ne prendra que 12 minutes`,
    howto1_body: 'Nous vous recommandons de faire ceci dans un environnement calme. Au besoin, faites-le plus tard.',
    award1_title: 'Vous avez fini la première étape, bravo !',
    award1_body: `En haut de la page suivante, vous trouverez ce que vous considérez comme étant le plus important dans votre environnement de travail idéal. Vérifiez que cela correspond à vos préférences, et au besoin, réordonnez l'ordre de ces déclarations en les faisant glisser.`,
    award2_title: 'Vous avez fait plus de la moitié du chemin !',
    award2_body: `Les déclarations les plus importantes se trouvent au sommet de la page suivante. Vérifiez l'ordre, et au besoin, réarrangez-les en les faisant glisser.`,
    award3_title: 'Félicitations pour la troisième partie',
    award3_body: `En haut de la page suivante, vous trouverez ce que vous considérez comme étant le plus important dans votre environnement de travail idéal. Vérifiez que cela correspond à vos préférences, et au besoin, réordonnez l'ordre de ces déclarations en les faisant glisser.`,
    howto2_title: 'Et maintenant la dernière étape - +/- 2 minutes',
    howto2_body: `Pouvez-vous ordonner les déclarations suivantes, de la plus importante (en haut) à la moins importante (en bas). `,
    title_rank: 'Dans mon environnement de travail **IDEAL**,',
    subtitle_rank_2: 'le plus important est :',
    subtitle_rank_n: "l'énoncé suivant est + ou - important?",
    hint_reorder: 'Réordonnez au besoin, du + au - important',
    hint_overview: 'Cliquez ci-dessous pour voir le récapitulatif',
    hint_profile: 'Mes préférences actuelles',
    hint_place_below: "Insérez l'énoncé ci-dessous",
    title_rank_bucket: 'Toutes dernières comparaisons',
    subtitle_rank_best: 'Cette fois, lequel est le PLUS important pour vous ?',
    subtitle_rank_least: 'Lequel est le MOINS important pour vous ?',
    subtitle_rank_reorder: 'Réordonnez, du PLUS au MOINS important',
    title_thanks: 'Merci pour votre participation !',
    hint_thanks: 'Merci ! Votre profil a été correctement envoyé à nos équipes.',
    title_error: 'Envoi impossible du profil',
    hint_error: 'Veuillez réessayer plus tard ...',
    hint_error_validation: 'Erreur de validation des données, veuillez réessayer plus tard',
    hint_error_dup: 'Vous avez déjà soumis un précédent rapport.',
    hint_confirm_round: 'Etes-vous sûrs de vouloir confirmer cet ordre ?',
    retry_btn: 'Réessayer',
    btn_to_overview: 'APERÇU',
    btn_to_bucket_x: 'GROUPE',
    btn_to_params: 'PARAMÈTRES',
    btn_open: 'OUVRIR',
    btn_start: 'DÉMARRER',
    btn_confirm: 'CONFIRMER',
    // btn_next: 'NEXT',
    btn_next: '>',
    btn_next_str: 'SUIVANT',
    btn_next_round: 'ETAPE SUIVANTE',
    // 'btn_prev': 'PRÉCÉDENT',
    btn_prev: '<',
    btn_cancel: 'ANNULER',
    // 'btn_back': 'RETOUR',
    btn_back: '<',
    btn_download: 'Télécharger votre rapport',
    btn_quit: 'QUITTER',
    // Comparaisons
    pick_best: 'Lequel est le plus important pour vous ?',
    pick_worst: 'Lequel est le moins important pour vous ?',
    vs: 'OU',
    // UI elements
    round: 'Etape',
    stm: 'Énoncé',
    bucket: 'Groupe',
    axis_y: "Nombre d'Énoncés",
    tip_saved: 'Enregistré',
    top_scale_hint: 'Le **PLUS** important',
    bottom_scale_hint: 'Le **MOINS** important',
    pick_tip: 'Choisissez !',
    how_to_binary_title: 'Instructions',
    // values
    samen: 'Collaboration',
    conf: 'Conformité',
    erken: 'Reconnaissance',
    zorg: 'Soin',
    gelijk: 'Égalité et diversité',
    zelfsturing: 'Autonomie',
    macht: 'Pouvoir',
    voorspelbaar: 'Prévisibilité',
    prestatie: 'Performance',
    zelfontplooi: 'Développement personnel',
    duurzaam: 'Durabilité',
    integriteit: 'Intégrité',
    innovatie: 'Innovation',
    daadkracht: 'Force',
    //
    no_slug_error: 'Veuillez vérifier que le lien est correct, ou contactez votre administrateur / support',
    unknown_error: 'Une erreur est survenue, veuillez réessayer plus tard',
    invalid_credentials: 'Combinaison Email / Mot de passe invalide',
    // 360:
    // TLTM Scale
    lvl0: 'Veuillez choisir',
    lvl1: 'Beaucoup trop peu',
    lvl2: 'Trop peu',
    lvl3: 'Plutôt trop peu',
    lvl4: 'Juste assez',
    lvl5: 'Un peu trop',
    lvl6: 'Trop',
    lvl7: 'Beaucoup Trop',
    lvlx1: '-3',
    lvlx2: '-2',
    lvlx3: '-1',
    lvlx4: 'Juste assez',
    lvlx5: '+1',
    lvlx6: '+2',
    lvlx7: '+3',
    // SCALE 10 lvlSC10x
    lvlSC10x00: 'Veuillez choisir',
    lvlSC10x00e: '🤔',
    //
    lvlSC10x0e: '😫',
    lvlSC10x0nps: 'Jamais',
    lvlSC10x0: 'Nul',
    lvlSC10x1e: '😖',
    lvlSC10x1nps: 'MISSING',
    lvlSC10x1: 'Extrêmement mauvais',
    lvlSC10x2e: '😣',
    lvlSC10x2nps: 'MISSING',
    lvlSC10x2: 'Très Mauvais',
    lvlSC10x3e: '😠',
    lvlSC10x3nps: 'MISSING',
    lvlSC10x3: 'Mauvais',
    lvlSC10x4e: '🙁',
    lvlSC10x4nps: 'MISSING',
    lvlSC10x4: 'Insuffisant',
    lvlSC10x5e: '😯',
    lvlSC10x5nps: 'MISSING',
    lvlSC10x5: 'Médiocre',
    lvlSC10x6e: '😐',
    lvlSC10x6nps: 'MISSING',
    lvlSC10x6: 'Moyen',
    lvlSC10x7e: '🙂',
    lvlSC10x7nps: 'MISSING',
    lvlSC10x7: 'Bon',
    lvlSC10x8e: '😊',
    lvlSC10x8nps: 'MISSING',
    lvlSC10x8: 'Très bon',
    lvlSC10x9e: '😃',
    lvlSC10x9nps: 'MISSING',
    lvlSC10x9: 'Excellent',
    lvlSC10x10e: '😍',
    lvlSC10x10nps: 'Certainement',
    lvlSC10x10: 'Impeccable',
    howto_360_title: `En tant qu'organisation nous accordons une grande importance aux valeurs, nous croyons qu'il est essentiel de savoir ce qui vous rend vraiment heureux dans votre environnement de travail.`,
    howto_360_body: `Ce questionnaire est et restera anonyme pour votre hiérarchie qui ne recevra que les résultats agrégés.`,
    picker_360_title_workenv: 'Dans mon environnement de travail actuel …',
    picker_360_title_leadership: 'Mon manager direct …',
    nps_title: 'Dans quelle mesure recommanderiez-vous de travailler ici?',
    comment_title: 'Ajouter un commentaire',
    comment_placeholder: 'Nous vous remercions pour tout commentaire constructif (400 caractères)',
    comment_save: 'Sauver et fermer',
    comment_remaining: 'caractère(s) libre(s)',
    howto_workenv_title: 'Partagez maintenant vos impressions sur votre environnement de travail actuel',
    howto_workenv_body: `Comment le vivez-vous ? Pensez aux procédures, à la gouvernance, aux systèmes, ... 
     N'hésitez pas à nous laisser un commentaire`,
    howto_nps_title: 'Recommanderiez-vous votre employeur comme lieu de travail ?',
    howto_nps_body: 'Sur une échelle de 0 à 10, quelle est la probabilité que vous recommandiez votre employeur comme lieu de travail à vos amis ou à votre famille ?',
    // legacy_v2:
    to_assign: 'A attribuer',
    least_important: 'Moins important',
    moderately_important: 'Moyennement important',
    most_important: 'Plus important',
    ranker_title: 'Qu\'est ce qui est important dans votre job idéal?',
    too_much_warning: 'Vous avez dépassé la limite de déclarations à attribuer',
    empty_bin: 'Ce groupe est vide',
    too_much_warning1: 'Vous avez attribué trop de déclarations au(x) groupe(s) :',
    too_much_warning2: 'Cliquez sur le groupe et réattribuez la/les déclaration(s) à un autre groupe jusqu\'à ce que la distribution soit correcte',
    too_insufficient_warning: 'Vous n\'avez pas attribué assez de déclarations',
    btn_next_step: 'Suivant',
    further_ranking: 'Veuillez classer ces {{v1}} déclarations du + au - important',
    further_ranking1: 'Veuillez classez ces {{v1}} affirmations',
    further_ranking2: 'Veuillez classer ces {{v1}} déclarations',
    hint_modal_title: 'Imaginez votre environnement de travail idéal',
    hint_modal_body1: 'Classez 42 déclarations sur votre environnement idéal du moins au plus important',
    hint_modal_body2_left: 'gauche',
    hint_modal_body2_left_txt: 'les 11 déclarations que vous trouvez les moins importantes',
    hint_modal_body2_right: 'droite',
    hint_modal_body2_right_txt: 'les 11 déclarations que vous trouvez les plus importantes',
    hint_modal_body2_middle: 'milieu',
    hint_modal_body2_middle_txt: 'les 20 déclarations que vous trouvez moyennement importantes',
    hint_modal_body3: 'Glissez-déposez chaque déclaration dans le panier qui vous convient le mieux',
    hint_modal_cta: 'Démarrer',
    hint_top: 'Défiler vers le haut',
    hint_down: 'Défiler vers le bas',
    // Modal strings
    sort_middle_bucket_title: 'Voulez-vous trier le groupe du milieu ?',
    sort_middle_bucket_body: 'Cela triera le groupe du milieu par valeur.',
    reflect_current_view_title: 'Est-ce que ceci reflète l\'environnement de votre job idéal ?',
    reflect_current_view_sort_body: 'Si non, vous serez invité à re-trier votre classement final',
    yes: 'Oui',
    no: 'Non',
    final_ranking: 'Classement final',
    final_distribution_invalid_title: 'La distribution finale est invalide',
    final_distribution_invalid_body: 'Il y a {{v1}} groupe(s) avec trop de déclarations et {{v2}} groupe(s) avec trop peu de déclarations',
    no_available_bins_warning: "Aucun groupe disponible pour l'assignation aléatoire - tous les groupes ont atteint leur capacité maximale",
    example: 'Exemple :',
}
